module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_3.9a465c63.png";